import React from 'react';
import PropTypes from 'prop-types';

import 'src/components/EmptyListing/EmptyListing.scss';


const EmptyListing = ({
  icon: Icon, header, link, copy, dataTest
}) => (
  <a data-test={ dataTest } href={ link } styleName="empty-listing" title={ header }>
    <div styleName="empty-listing__icon">
      <Icon styleName="empty-listing__badge" viewBox="0 0 24 24" />
    </div>
    <h3 styleName="empty-listing__header">
      {header}
    </h3>
    { copy }
  </a>
);

EmptyListing.propTypes = {
  copy: PropTypes.node.isRequired,
  dataTest: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  icon: PropTypes.func.isRequired,
  link: PropTypes.string.isRequired
};


export default EmptyListing;
